import * as yup from 'yup';

export interface ConfirmMfaFormData {
  passcode: string;
}

export const mfaFormValidationSchema = yup.object({
  passcode: yup.string().required('Required'),
});
